import Enum from "./Enum";

export default Enum.create( {
	COMPLETE: "COMPLETE",
	DUE_IN_NEXT_WEEK: "DUE_IN_NEXT_WEEK",
	NO_DUE_DATE: "NO_DUE_DATE",
	OUTSTANDING: "OUTSTANDING",
	OVERDUE: "OVERDUE",
} );
